import * as types from '../../mutation-types.js'

const actions = {
  setAlert ({ commit, state }, task) {
    commit(types.SET_ALERT, {
      alert: task
    })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/Alert/actions.js